import React, { createContext, useState, useCallback } from 'react';
import UnsavedChangesModal from '../components/common/UnsavedChangesModal/UnsavedChangesModal';

const UnsavedChangesContext = createContext(null);

export const UnsavedChangesProvider = ({ children }) => {
  const [modalState, setModalState] = useState({
    show: false,
    onConfirm: null,
    onCancel: null,
  });

  const showModal = useCallback(({ onConfirm, onCancel }) => {
    setModalState({ show: true, onConfirm, onCancel });
  }, []);

  const hideModal = useCallback(() => {
    setModalState({
      show: false,
      onConfirm: null,
      onCancel: null,
    });
  }, []);

  return (
    <UnsavedChangesContext.Provider value={{ showModal, hideModal }}>
      {children}
      <UnsavedChangesModal
        showPrompt={modalState.show}
        onConfirm={modalState.onConfirm || (() => {})}
        onCancel={modalState.onCancel || (() => {})}
      />
    </UnsavedChangesContext.Provider>
  );
};

export default UnsavedChangesContext;
